import React from "react";
import { Typography, Box, Button, Dialog, DialogContent } from "@mui/material";

const SuccessErrorMessagePopUp = (props) => {
  const { showPopUp, onDoneClick, message, title } = props;
  return (
    <Box>
      <Dialog open={showPopUp} className="app-dialog">
        <DialogContent sx={{ padding: "40px" }}>
          <Box
            component="div"
            sx={{
              textAlign: "center",
            }}
          >
            <Box mb={4}>
              <Typography variant="text2">{title}</Typography>
            </Box>
            {message ? (
              <Box mb={7}>
                <Typography variant="text3" sx={{ color: "#607277" }}>
                  {message}
                </Typography>
              </Box>
            ) : null}
            <Box>
              <Button
                variant="large"
                onClick={() => onDoneClick()}
                sx={{ minWidth: { xs: "150px", sm: "150px", md: undefined } }}
              >
                DONE
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SuccessErrorMessagePopUp;
